module.exports = __webpack_public_path__ + "static/media/IMG_20160419_014804.38629094.jpg";